import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/formulario.css';
import CustomNavbar from './Navbar/Navbar';
import PuestoSelect from './PuestoSelect';
import { validateField, validateAllFields, ErrorMessage, SuccessMessage, validarFechasExperiencia } from './ValidationUtils';

const Formulario = () => {
    const MESES = [
        { value: '01', label: 'Enero' },
        { value: '02', label: 'Febrero' },
        { value: '03', label: 'Marzo' },
        { value: '04', label: 'Abril' },
        { value: '05', label: 'Mayo' },
        { value: '06', label: 'Junio' },
        { value: '07', label: 'Julio' },
        { value: '08', label: 'Agosto' },
        { value: '09', label: 'Septiembre' },
        { value: '10', label: 'Octubre' },
        { value: '11', label: 'Noviembre' },
        { value: '12', label: 'Diciembre' }
    ];

    const generarAnios = () => {
        const anioActual = new Date().getFullYear();
        const anios = [];
        for (let i = anioActual; i >= 1970; i--) {
            anios.push(i);
        }
        return anios;
    };

    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        nacionalidad: '',
        fechaNacimiento: '',
        estadoCivil: '',
        tipoDocumento: '',
        cedula: '',
        genero: '',
        telefono: '',
        provincia: '',
        canton: '',
        direccion: '',
        email: '',
        preferenciaSalarial: '',
        discapacidad: '',
        porcentajeDiscapacidad: '',
        trabajadoEnConduto: '',

        formacionesAcademicas: [
            {
                titulo: '',
                tipoEstudio: '',
                areaEstudio: '',
                institucion: '',
                estadoEstudio: '',
                fechaInicioEstudio: '',
                fechaFinEstudio: ''
            }
        ],

        idiomas: [
            {
                idioma: '',
                otroIdioma: '',
                nivelEscrito: '',
                nivelOral: ''
            }
        ],

        trabajadoEnConduto: '',

        experiencias: [
            {
                empresa: '',
                actividadEmpresa: '',
                puesto: '',
                otroPuesto: '',
                nivelExperiencia: '',
                paisEmpresa: '',
                fechaInicioExperiencia: { mes: '', año: '' },
                fechaFinalizacionExperiencia: { mes: '', año: '' },
                descripcionResponsabilidad: '',
                personasCargo: ''
            }
        ],
        cv: ''
    });

    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [showSuccess, setShowSuccess] = useState(false);

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;

        if (errors[name] || errors.submit) {
            setErrors(prev => {
                const newPrev = { ...prev };
                if (newPrev[name]) delete newPrev[name];
                if (newPrev.submit) delete newPrev.submit;
                return newPrev;
            });
        }

        if (name === 'discapacidad') {
            setFormData(prevState => ({
                ...prevState,
                discapacidad: value,
                porcentajeDiscapacidad: value === 'Sí' ? prevState.porcentajeDiscapacidad : ''
            }));

            if (value !== 'Sí' && (errors.porcentajeDiscapacidad || errors.submit)) {
                setErrors(prev => {
                    const newPrev = { ...prev };
                    delete newPrev.porcentajeDiscapacidad;
                    delete newPrev.submit;
                    return newPrev;
                });
            }

            return;
        }

        if (type === 'file') {
            setFormData(prevState => ({
                ...prevState,
                [name]: files[0]
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }

        const fieldError = validateField(name, value);
        if (fieldError) {
            setErrors(prev => ({ ...prev, [name]: fieldError }));
        }
    };

    const handleFormacionChange = (index, field, value) => {
        const errorKey = `formacion_${index}_${field}`;
        if (errors[errorKey]) {
            setErrors(prev => ({ ...prev, [errorKey]: '' }));
        }

        const updatedFormaciones = formData.formacionesAcademicas.map((formacion, i) => {
            if (i === index) {
                const newFormacion = { ...formacion, [field]: value };

                if (field === 'fechaInicioEstudio' || field === 'fechaFinEstudio') {
                    const fechaInicio = field === 'fechaInicioEstudio' ? value : formacion.fechaInicioEstudio;
                    const fechaFin = field === 'fechaFinEstudio' ? value : formacion.fechaFinEstudio;

                    if (fechaInicio && fechaFin) {
                        const yearInicio = parseInt(fechaInicio);
                        const yearFin = parseInt(fechaFin);
                        const currentYear = new Date().getFullYear();

                        if (yearFin > currentYear) {
                            setErrors(prev => ({
                                ...prev,
                                [`formacion_${index}_fechaFinEstudio`]: `El año de fin no puede ser mayor al año actual (${currentYear})`
                            }));
                        } else if (yearInicio > yearFin) {
                            setErrors(prev => ({
                                ...prev,
                                [`formacion_${index}_${field}`]: 'El año de inicio no puede ser mayor al año de finalización'
                            }));
                        }
                    }
                }

                return newFormacion;
            }
            return formacion;
        });

        setFormData(prevState => ({
            ...prevState,
            formacionesAcademicas: updatedFormaciones
        }));
    };

    const agregarFormacion = () => {
        setFormData(prevState => ({
            ...prevState,
            formacionesAcademicas: [
                ...prevState.formacionesAcademicas,
                {
                    titulo: '',
                    tipoEstudio: '',
                    areaEstudio: '',
                    institucion: '',
                    estadoEstudio: '',
                    fechaInicioEstudio: '',
                    fechaFinEstudio: ''
                }
            ]
        }));
    };

    const eliminarFormacion = (index) => {
        if (formData.formacionesAcademicas.length > 1) {
            const updatedFormaciones = formData.formacionesAcademicas.filter((_, i) => i !== index);
            setFormData(prevState => ({
                ...prevState,
                formacionesAcademicas: updatedFormaciones
            }));
        }
    };

    const handleRadioChange = (e) => {
        const { name, value } = e.target;

        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }

        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleIdiomaChange = (index, field, value) => {
        const errorKey = `idioma_${index}_${field}`;
        if (errors[errorKey]) {
            setErrors(prev => ({ ...prev, [errorKey]: '' }));
        }

        const updatedIdiomas = formData.idiomas.map((idioma, i) => {
            if (i === index) {
                return { ...idioma, [field]: value };
            }
            return idioma;
        });

        setFormData(prevState => ({
            ...prevState,
            idiomas: updatedIdiomas
        }));
    };

    const agregarIdioma = () => {
        setFormData(prevState => ({
            ...prevState,
            idiomas: [
                ...prevState.idiomas,
                {
                    idioma: '',
                    otroIdioma: '',
                    nivelEscrito: '',
                    nivelOral: ''
                }
            ]
        }));
    };

    const eliminarIdioma = (index) => {
        if (formData.idiomas.length > 1) {
            const updatedIdiomas = formData.idiomas.filter((_, i) => i !== index);
            setFormData(prevState => ({
                ...prevState,
                idiomas: updatedIdiomas
            }));
        }
    };

    const handleExperienciaFechaChange = (index, tipoFecha, campo, value) => {
        const fieldKey = tipoFecha === 'inicio' ? 'fechaInicioExperiencia' : 'fechaFinalizacionExperiencia';

        const updatedExperiencias = formData.experiencias.map((experiencia, i) => {
            if (i === index) {
                const nuevaFecha = {
                    ...experiencia[fieldKey],
                    [campo]: value
                };

                setErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors[`experiencia_${index}_fechaInicio`];
                    delete newErrors[`experiencia_${index}_fechaFinalizacion`];

                    if (value) {
                        const specificKey = `experiencia_${index}_` + (tipoFecha === 'inicio' ? (campo === 'mes' ? 'fechaInicioMes' : 'fechaInicioAnio') : (campo === 'mes' ? 'fechaFinMes' : 'fechaFinAnio'));
                        delete newErrors[specificKey];
                    }

                    if (newErrors.submit) delete newErrors.submit;
                    return newErrors;
                });

                if (campo === 'mes' && !value) {
                    setErrors(prev => ({
                        ...prev,
                        [`experiencia_${index}_${tipoFecha === 'inicio' ? 'fechaInicioMes' : 'fechaFinMes'}`]: 'El mes es requerido'
                    }));
                }

                if (campo === 'año' && !value) {
                    setErrors(prev => ({
                        ...prev,
                        [`experiencia_${index}_${tipoFecha === 'inicio' ? 'fechaInicioAnio' : 'fechaFinAnio'}`]: 'El año es requerido'
                    }));
                }

                if (tipoFecha === 'inicio' && experiencia.fechaFinalizacionExperiencia.mes && experiencia.fechaFinalizacionExperiencia.año) {
                    const error = validarFechasExperiencia(nuevaFecha, experiencia.fechaFinalizacionExperiencia);
                    if (error) {
                        setErrors(prev => ({
                            ...prev,
                            [`experiencia_${index}_fechaInicio`]: error
                        }));
                    }
                }

                if (tipoFecha === 'fin' && experiencia.fechaInicioExperiencia.mes && experiencia.fechaInicioExperiencia.año) {
                    const error = validarFechasExperiencia(experiencia.fechaInicioExperiencia, nuevaFecha);
                    if (error) {
                        setErrors(prev => ({
                            ...prev,
                            [`experiencia_${index}_fechaFinalizacion`]: error
                        }));
                    }
                }

                return {
                    ...experiencia,
                    [fieldKey]: nuevaFecha
                };
            }
            return experiencia;
        });

        setFormData(prevState => ({
            ...prevState,
            experiencias: updatedExperiencias
        }));
    };

    const handleExperienciaChange = (index, field, value) => {
        // Clear field-level error and global submit error when user edits an experiencia field
        const determineErrorKey = (f) => f === 'puestoData' ? `experiencia_${index}_puesto` : `experiencia_${index}_${f}`;
        const errorKey = determineErrorKey(field);

        setErrors(prev => {
            const next = { ...prev };
            if (next[errorKey]) delete next[errorKey];
            // If puestoData changed, also clear related otroPuesto error
            if (field === 'puestoData') {
                delete next[`experiencia_${index}_otroPuesto`];
            }
            if (next.submit) delete next.submit;
            return next;
        });

        const updatedExperiencias = formData.experiencias.map((experiencia, i) => {
            if (i === index) {
                if (field === 'puestoData') {
                    return {
                        ...experiencia,
                        puesto: value.puesto,
                        otroPuesto: value.otroPuesto
                    };
                }
                return { ...experiencia, [field]: value };
            }
            return experiencia;
        });

        setFormData(prevState => ({
            ...prevState,
            experiencias: updatedExperiencias
        }));
    };

    const agregarExperiencia = () => {
        setFormData(prevState => ({
            ...prevState,
            experiencias: [
                ...prevState.experiencias,
                {
                    empresa: '',
                    actividadEmpresa: '',
                    puesto: '',
                    nivelExperiencia: '',
                    paisEmpresa: '',
                    fechaInicioExperiencia: { mes: '', año: '' },
                    fechaFinalizacionExperiencia: { mes: '', año: '' },
                    descripcionResponsabilidad: '',
                    personasCargo: ''
                }
            ]
        }));
    };

    const eliminarExperiencia = (index) => {
        if (formData.experiencias.length > 1) {
            const updatedExperiencias = formData.experiencias.filter((_, i) => i !== index);
            setFormData(prevState => ({
                ...prevState,
                experiencias: updatedExperiencias
            }));
        }
    };

    const isFormValid = () => {
        const validationErrors = validateAllFields(formData);
        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0 && acceptedTerms;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate fields and show global message when there are validation errors
        const validationErrors = validateAllFields(formData);
        if (Object.keys(validationErrors).length > 0 || !acceptedTerms) {
            const newErrors = { ...validationErrors };
            if (!acceptedTerms) {
                newErrors.terms = 'Debe aceptar los términos y condiciones';
            }
            if (Object.keys(validationErrors).length > 0) {
                newErrors.submit = 'Hay campos vacíos o con problemas de formato';
            }
            setErrors(newErrors);
            return;
        }

        setIsSubmitting(true);

        try {
            const experienciasFormateadas = formData.experiencias.map(exp => ({
                ...exp,
                fechaInicioExperiencia: exp.fechaInicioExperiencia.año && exp.fechaInicioExperiencia.mes
                    ? `${exp.fechaInicioExperiencia.año}-${exp.fechaInicioExperiencia.mes}`
                    : '',
                fechaFinalizacionExperiencia: exp.fechaFinalizacionExperiencia.año && exp.fechaFinalizacionExperiencia.mes
                    ? `${exp.fechaFinalizacionExperiencia.año}-${exp.fechaFinalizacionExperiencia.mes}`
                    : ''
            }));

            const submitData = new FormData();

            const simpleFields = [
                'nombre', 'apellido', 'nacionalidad', 'fechaNacimiento', 'estadoCivil',
                'tipoDocumento', 'cedula', 'genero', 'telefono', 'provincia', 'canton',
                'direccion', 'email', 'preferenciaSalarial', 'discapacidad', 'porcentajeDiscapacidad',
                'trabajadoEnConduto'
            ];

            simpleFields.forEach(field => {
                if (formData[field] !== undefined && formData[field] !== null) {
                    submitData.append(field, formData[field].toString());
                }
            });

            submitData.append('autoriza', acceptedTerms ? '1' : '0');

            submitData.append('idiomas', JSON.stringify(formData.idiomas || []));
            submitData.append('formacionesAcademicas', JSON.stringify(formData.formacionesAcademicas || []));
            submitData.append('experiencias', JSON.stringify(experienciasFormateadas || []));

            if (formData.cv) {
                submitData.append('cv', formData.cv);
            }

            const response = await fetch('https://apicv.conduto.com.ec/api/guardar-hoja-vida', {
                method: 'POST',
                body: submitData
            });

            const result = await response.json();

            if (result.success) {
                setShowSuccess(true);

                setFormData({
                    nombre: '',
                    apellido: '',
                    nacionalidad: '',
                    fechaNacimiento: '',
                    estadoCivil: '',
                    tipoDocumento: '',
                    cedula: '',
                    genero: '',
                    telefono: '',
                    provincia: '',
                    canton: '',
                    direccion: '',
                    email: '',
                    preferenciaSalarial: '',
                    discapacidad: '',
                    porcentajeDiscapacidad: '',
                    trabajadoEnConduto: '',

                    formacionesAcademicas: [
                        {
                            titulo: '',
                            tipoEstudio: '',
                            areaEstudio: '',
                            institucion: '',
                            estadoEstudio: '',
                            fechaInicioEstudio: '',
                            fechaFinEstudio: ''
                        }
                    ],

                    idiomas: [
                        {
                            idioma: '',
                            otroIdioma: '',
                            nivelEscrito: '',
                            nivelOral: ''
                        }
                    ],

                    experiencias: [
                        {
                            empresa: '',
                            actividadEmpresa: '',
                            puesto: '',
                            otroPuesto: '',
                            nivelExperiencia: '',
                            paisEmpresa: '',
                            fechaInicioExperiencia: { mes: '', año: '' },
                            fechaFinalizacionExperiencia: { mes: '', año: '' },
                            descripcionResponsabilidad: '',
                            personasCargo: ''
                        }
                    ],
                    cv: ''
                });

                setAcceptedTerms(false);
                setErrors({});

                const fileInput = document.querySelector('input[name="cv"]');
                if (fileInput) {
                    fileInput.value = '';
                }

            } else {
                setErrors({ submit: 'Error al guardar la hoja de vida' });
            }

        } catch (error) {
            console.error('Error al enviar el formulario:', error);
            setErrors({ submit: `Error al guardar: ${error.message}` });
        } finally {
            setIsSubmitting(false);
        }
    };


    const RequiredAsterisk = () => <span className="text-danger">*</span>;

    return (
        <div className="container">
            <CustomNavbar />
            <div className="">
                <div className="card-header">
                    <h2 className="text-center mb-4">HOJA DE VIDA</h2>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit} encType="multipart/form-data">

                        <div className="mb-4 formacion-item-content border p-3 mb-3 rounded">
                            <h4 className="border-bottom pb-2">DATOS PERSONALES</h4>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Nombres <RequiredAsterisk /></label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.nombre ? 'is-invalid' : ''}`}
                                        name="nombre"
                                        value={formData.nombre}
                                        onChange={handleInputChange}
                                    />
                                    {errors.nombre && <div className="invalid-feedback">{errors.nombre}</div>}
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Apellidos <RequiredAsterisk /></label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.apellido ? 'is-invalid' : ''}`}
                                        name="apellido"
                                        value={formData.apellido}
                                        onChange={handleInputChange}
                                    />
                                    {errors.apellido && <div className="invalid-feedback">{errors.apellido}</div>}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Nacionalidad <RequiredAsterisk /></label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.nacionalidad ? 'is-invalid' : ''}`}
                                        name="nacionalidad"
                                        value={formData.nacionalidad}
                                        onChange={handleInputChange}
                                    />
                                    {errors.nacionalidad && <div className="invalid-feedback">{errors.nacionalidad}</div>}
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Fecha de Nacimiento <RequiredAsterisk /></label>
                                    <input
                                        type="date"
                                        className={`form-control ${errors.fechaNacimiento ? 'is-invalid' : ''}`}
                                        name="fechaNacimiento"
                                        value={formData.fechaNacimiento}
                                        onChange={handleInputChange}
                                    />
                                    {errors.fechaNacimiento && <div className="invalid-feedback">{errors.fechaNacimiento}</div>}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Estado Civil <RequiredAsterisk /></label>
                                    <select
                                        className={`form-select ${errors.estadoCivil ? 'is-invalid' : ''}`}
                                        name="estadoCivil"
                                        value={formData.estadoCivil}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Seleccionar</option>
                                        <option value="Soltero">Soltero</option>
                                        <option value="Casado">Casado</option>
                                        <option value="Divorciado">Divorciado</option>
                                        <option value="Separado">Separado</option>
                                        <option value="Unión libre">Unión libre</option>
                                    </select>
                                    {errors.estadoCivil && <div className="invalid-feedback">{errors.estadoCivil}</div>}
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Tipo de Documento <RequiredAsterisk /></label>
                                    <select
                                        className={`form-select ${errors.tipoDocumento ? 'is-invalid' : ''}`}
                                        name="tipoDocumento"
                                        value={formData.tipoDocumento}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Seleccionar</option>
                                        <option value="Cédula">Cédula</option>
                                        <option value="Pasaporte">Pasaporte</option>
                                    </select>
                                    {errors.tipoDocumento && <div className="invalid-feedback">{errors.tipoDocumento}</div>}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">No. Cédula <RequiredAsterisk /></label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.cedula ? 'is-invalid' : ''}`}
                                        name="cedula"
                                        value={formData.cedula}
                                        onChange={handleInputChange}
                                    />
                                    {errors.cedula && <div className="invalid-feedback">{errors.cedula}</div>}
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Género <RequiredAsterisk /></label>
                                    <select
                                        className={`form-select ${errors.genero ? 'is-invalid' : ''}`}
                                        name="genero"
                                        value={formData.genero}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Seleccionar</option>
                                        <option value="Femenino">Femenino</option>
                                        <option value="Masculino">Masculino</option>
                                        <option value="Otro">Otro</option>
                                    </select>
                                    {errors.genero && <div className="invalid-feedback">{errors.genero}</div>}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Teléfono Celular <RequiredAsterisk /></label>
                                    <input
                                        type="tel"
                                        className={`form-control ${errors.telefono ? 'is-invalid' : ''}`}
                                        name="telefono"
                                        value={formData.telefono}
                                        onChange={handleInputChange}
                                    />
                                    {errors.telefono && <div className="invalid-feedback">{errors.telefono}</div>}
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Provincia <RequiredAsterisk /></label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.provincia ? 'is-invalid' : ''}`}
                                        name="provincia"
                                        value={formData.provincia}
                                        onChange={handleInputChange}
                                    />
                                    {errors.provincia && <div className="invalid-feedback">{errors.provincia}</div>}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Cantón <RequiredAsterisk /></label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.canton ? 'is-invalid' : ''}`}
                                        name="canton"
                                        value={formData.canton}
                                        onChange={handleInputChange}
                                    />
                                    {errors.canton && <div className="invalid-feedback">{errors.canton}</div>}
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Dirección <RequiredAsterisk /></label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.direccion ? 'is-invalid' : ''}`}
                                        name="direccion"
                                        value={formData.direccion}
                                        onChange={handleInputChange}
                                    />
                                    {errors.direccion && <div className="invalid-feedback">{errors.direccion}</div>}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Email <RequiredAsterisk /></label>
                                    <input
                                        type="email"
                                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                    />
                                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Preferencia Salarial <RequiredAsterisk /></label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.preferenciaSalarial ? 'is-invalid' : ''}`}
                                        name="preferenciaSalarial"
                                        value={formData.preferenciaSalarial}
                                        onChange={handleInputChange}
                                    />
                                    {errors.preferenciaSalarial && <div className="invalid-feedback">{errors.preferenciaSalarial}</div>}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Discapacidad</label>
                                    <select
                                        className={`form-select ${errors.discapacidad ? 'is-invalid' : ''}`}
                                        name="discapacidad"
                                        value={formData.discapacidad}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Seleccionar</option>
                                        <option value="Sí">Sí</option>
                                        <option value="No">No</option>
                                    </select>
                                    {errors.discapacidad && <div className="invalid-feedback">{errors.discapacidad}</div>}
                                </div>
                                {formData.discapacidad === 'Sí' && (
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">% Discapacidad <RequiredAsterisk /></label>
                                        <input
                                            type="number"
                                            className={`form-control ${errors.porcentajeDiscapacidad ? 'is-invalid' : ''}`}
                                            name="porcentajeDiscapacidad"
                                            value={formData.porcentajeDiscapacidad}
                                            onChange={handleInputChange}
                                            min="0"
                                            max="100"
                                        />
                                        {errors.porcentajeDiscapacidad && <div className="invalid-feedback">{errors.porcentajeDiscapacidad}</div>}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="mb-4 formacion-item-content border p-3 mb-3 rounded">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="border-bottom pb-2 mb-0">FORMACIÓN ACADÉMICA</h4>
                                <button
                                    type="button"
                                    className="btn btn-success btn-sm"
                                    onClick={agregarFormacion}
                                >
                                    + Agregar Formación
                                </button>
                            </div>

                            {formData.formacionesAcademicas.map((formacion, index) => (
                                <div key={index} className="formacion-item border p-3 mb-3 rounded">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h6 className="mb-0">Formación Académica #{index + 1}</h6>
                                        {formData.formacionesAcademicas.length > 1 && (
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() => eliminarFormacion(index)}
                                            >
                                                × Eliminar
                                            </button>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Título / Carrera <RequiredAsterisk /></label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`formacion_${index}_titulo`] ? 'is-invalid' : ''}`}
                                                value={formacion.titulo}
                                                onChange={(e) => handleFormacionChange(index, 'titulo', e.target.value)}
                                            />
                                            {errors[`formacion_${index}_titulo`] && <div className="invalid-feedback">{errors[`formacion_${index}_titulo`]}</div>}
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Tipo de Estudio <RequiredAsterisk /></label>
                                            <select
                                                className={`form-select ${errors[`formacion_${index}_tipoEstudio`] ? 'is-invalid' : ''}`}
                                                value={formacion.tipoEstudio}
                                                onChange={(e) => handleFormacionChange(index, 'tipoEstudio', e.target.value)}
                                            >
                                                <option value="">Seleccionar</option>
                                                <option value="Bachiller">Básico</option>
                                                <option value="Bachiller">Bachiller</option>
                                                <option value="Técnico">Técnico</option>
                                                <option value="Universitario">Universitario</option>
                                                <option value="Diplomado">Diplomado</option>
                                                <option value="Post grado">Post grado</option>
                                                <option value="Master">Master</option>
                                                <option value="Doctorado">Doctorado</option>
                                            </select>
                                            {errors[`formacion_${index}_tipoEstudio`] && <div className="invalid-feedback">{errors[`formacion_${index}_tipoEstudio`]}</div>}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Área de Estudio <RequiredAsterisk /></label>
                                            <select
                                                className={`form-select ${errors[`formacion_${index}_areaEstudio`] ? 'is-invalid' : ''}`}
                                                value={formacion.areaEstudio}
                                                onChange={(e) => handleFormacionChange(index, 'areaEstudio', e.target.value)}
                                            >
                                                <option value="">Seleccionar</option>
                                                <option value="Ciencias de la Salud">Ciencias de la Salud</option>
                                                <option value="Ingeniería y Tecnología">Ingeniería y Tecnología</option>
                                                <option value="Ciencias Sociales y Humanidades">Ciencias Sociales y Humanidades</option>
                                                <option value="Negocios y Economía">Negocios y Economía</option>
                                            </select>
                                            {errors[`formacion_${index}_areaEstudio`] && <div className="invalid-feedback">{errors[`formacion_${index}_areaEstudio`]}</div>}
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Institución <RequiredAsterisk /></label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`formacion_${index}_institucion`] ? 'is-invalid' : ''}`}
                                                value={formacion.institucion}
                                                onChange={(e) => handleFormacionChange(index, 'institucion', e.target.value)}
                                            />
                                            {errors[`formacion_${index}_institucion`] && <div className="invalid-feedback">{errors[`formacion_${index}_institucion`]}</div>}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Estado <RequiredAsterisk /></label>
                                            <select
                                                className={`form-select ${errors[`formacion_${index}_estadoEstudio`] ? 'is-invalid' : ''}`}
                                                value={formacion.estadoEstudio}
                                                onChange={(e) => handleFormacionChange(index, 'estadoEstudio', e.target.value)}
                                            >
                                                <option value="">Seleccionar</option>
                                                <option value="En curso">En curso</option>
                                                <option value="Graduado">Graduado</option>
                                                <option value="Abandonado">Abandonado</option>
                                            </select>
                                            {errors[`formacion_${index}_estadoEstudio`] && <div className="invalid-feedback">{errors[`formacion_${index}_estadoEstudio`]}</div>}
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Año Inicio <RequiredAsterisk /></label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`formacion_${index}_fechaInicioEstudio`] ? 'is-invalid' : ''}`}
                                                value={formacion.fechaInicioEstudio}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                                                    handleFormacionChange(index, 'fechaInicioEstudio', value);
                                                }}
                                                maxLength="4"
                                                pattern="\d{4}"
                                                placeholder="YYYY"
                                            />
                                            {errors[`formacion_${index}_fechaInicioEstudio`] && <div className="invalid-feedback">{errors[`formacion_${index}_fechaInicioEstudio`]}</div>}
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Año Fin <RequiredAsterisk /></label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`formacion_${index}_fechaFinEstudio`] ? 'is-invalid' : ''}`}
                                                value={formacion.fechaFinEstudio}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                                                    handleFormacionChange(index, 'fechaFinEstudio', value);
                                                }}
                                                maxLength="4"
                                                pattern="\d{4}"
                                                placeholder="YYYY"
                                            />
                                            {errors[`formacion_${index}_fechaFinEstudio`] && <div className="invalid-feedback">{errors[`formacion_${index}_fechaFinEstudio`]}</div>}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="mb-4 formacion-item-content border p-3 mb-3 rounded">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="border-bottom pb-2 mb-0">IDIOMAS</h4>
                                <button
                                    type="button"
                                    className="btn btn-success btn-sm"
                                    onClick={agregarIdioma}
                                >
                                    + Agregar Idioma
                                </button>
                            </div>

                            {formData.idiomas.map((idioma, index) => (
                                <div key={index} className="idioma-item border p-3 mb-3 rounded">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h6 className="mb-0">Idioma #{index + 1}</h6>
                                        {formData.idiomas.length > 1 && (
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() => eliminarIdioma(index)}
                                            >
                                                × Eliminar
                                            </button>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Idioma <RequiredAsterisk /></label>
                                            <select
                                                className={`form-select ${errors[`idioma_${index}_idioma`] ? 'is-invalid' : ''}`}
                                                value={idioma.idioma}
                                                onChange={(e) => handleIdiomaChange(index, 'idioma', e.target.value)}
                                            >
                                                <option value="">Seleccionar</option>
                                                <option value="Inglés">Inglés</option>
                                                <option value="Mandarin">Mandarin</option>
                                                <option value="Español">Español</option>
                                                <option value="Francés">Francés</option>
                                                <option value="Italiano">Italiano</option>
                                                <option value="Portugués">Portugués</option>
                                                <option value="Otros">Otros</option>
                                            </select>
                                            {errors[`idioma_${index}_idioma`] && <div className="invalid-feedback">{errors[`idioma_${index}_idioma`]}</div>}
                                        </div>

                                        {idioma.idioma === "Otros" && (
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Especifique el idioma <RequiredAsterisk /></label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors[`idioma_${index}_otroIdioma`] ? 'is-invalid' : ''}`}
                                                    value={idioma.otroIdioma}
                                                    onChange={(e) => handleIdiomaChange(index, 'otroIdioma', e.target.value)}
                                                    placeholder="Especifique el idioma"
                                                />
                                                {errors[`idioma_${index}_otroIdioma`] && <div className="invalid-feedback">{errors[`idioma_${index}_otroIdioma`]}</div>}
                                            </div>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Nivel Escrito <RequiredAsterisk /></label>
                                            <select
                                                className={`form-select ${errors[`idioma_${index}_nivelEscrito`] ? 'is-invalid' : ''}`}
                                                value={idioma.nivelEscrito}
                                                onChange={(e) => handleIdiomaChange(index, 'nivelEscrito', e.target.value)}
                                            >
                                                <option value="">Seleccionar</option>
                                                <option value="Básico">Básico</option>
                                                <option value="Intermedio">Intermedio</option>
                                                <option value="Avanzado">Avanzado</option>
                                            </select>
                                            {errors[`idioma_${index}_nivelEscrito`] && <div className="invalid-feedback">{errors[`idioma_${index}_nivelEscrito`]}</div>}
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Nivel Oral <RequiredAsterisk /></label>
                                            <select
                                                className={`form-select ${errors[`idioma_${index}_nivelOral`] ? 'is-invalid' : ''}`}
                                                value={idioma.nivelOral}
                                                onChange={(e) => handleIdiomaChange(index, 'nivelOral', e.target.value)}
                                            >
                                                <option value="">Seleccionar</option>
                                                <option value="Básico">Básico</option>
                                                <option value="Intermedio">Intermedio</option>
                                                <option value="Avanzado">Avanzado</option>
                                            </select>
                                            {errors[`idioma_${index}_nivelOral`] && <div className="invalid-feedback">{errors[`idioma_${index}_nivelOral`]}</div>}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="mb-4 formacion-item-content border p-3 mb-3 rounded">
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <label className="form-label">
                                        ¿Ha trabajado en CONDUTO antes? <RequiredAsterisk />
                                    </label>
                                    <div className="mt-2">
                                        <div className="form-check form-check-inline">
                                            <input
                                                className={`form-check-input ${errors.trabajadoEnConduto ? 'is-invalid' : ''}`}
                                                type="radio"
                                                name="trabajadoEnConduto"
                                                id="trabajadoSi"
                                                value="si"
                                                checked={formData.trabajadoEnConduto === 'si'}
                                                onChange={handleRadioChange}
                                            />
                                            <label className="form-check-label" htmlFor="trabajadoSi">
                                                Sí
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className={`form-check-input ${errors.trabajadoEnConduto ? 'is-invalid' : ''}`}
                                                type="radio"
                                                name="trabajadoEnConduto"
                                                id="trabajadoNo"
                                                value="no"
                                                checked={formData.trabajadoEnConduto === 'no'}
                                                onChange={handleRadioChange}
                                            />
                                            <label className="form-check-label" htmlFor="trabajadoNo">
                                                No
                                            </label>
                                        </div>
                                    </div>
                                    {errors.trabajadoEnConduto && (
                                        <div className="invalid-feedback d-block">{errors.trabajadoEnConduto}</div>
                                    )}
                                </div>
                            </div>
                        </div>


                        <div className="mb-4 formacion-item-content border p-3 mb-3 rounded">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="border-bottom pb-2 mb-0">EXPERIENCIA</h4>
                                <button
                                    type="button"
                                    className="btn btn-success btn-sm"
                                    onClick={agregarExperiencia}
                                >
                                    + Agregar Experiencia
                                </button>
                            </div>

                            <p className="ms-2 fst-italic mb-3">Colocar desde la última experiencia laboral</p>

                            {formData.experiencias.map((experiencia, index) => (
                                <div key={index} className="experiencia-item border p-3 mb-3 rounded">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h6 className="mb-0">Experiencia #{index + 1}</h6>
                                        {formData.experiencias.length > 1 && (
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() => eliminarExperiencia(index)}
                                            >
                                                × Eliminar
                                            </button>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Empresa <RequiredAsterisk /></label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`experiencia_${index}_empresa`] ? 'is-invalid' : ''}`}
                                                value={experiencia.empresa}
                                                onChange={(e) => handleExperienciaChange(index, 'empresa', e.target.value)}
                                            />
                                            {errors[`experiencia_${index}_empresa`] && <div className="invalid-feedback">{errors[`experiencia_${index}_empresa`]}</div>}
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Actividad de la empresa <RequiredAsterisk /></label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`experiencia_${index}_actividadEmpresa`] ? 'is-invalid' : ''}`}
                                                value={experiencia.actividadEmpresa}
                                                onChange={(e) => handleExperienciaChange(index, 'actividadEmpresa', e.target.value)}
                                            />
                                            {errors[`experiencia_${index}_actividadEmpresa`] && <div className="invalid-feedback">{errors[`experiencia_${index}_actividadEmpresa`]}</div>}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <PuestoSelect
                                                value={{
                                                    puesto: experiencia.puesto,
                                                    otroPuesto: experiencia.otroPuesto
                                                }}
                                                onChange={(puestoData) => handleExperienciaChange(index, 'puestoData', puestoData)}
                                                error={errors[`experiencia_${index}_puesto`]}
                                                index={index}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Nivel de experiencia <RequiredAsterisk /></label>
                                            <select
                                                className={`form-select ${errors[`experiencia_${index}_nivelExperiencia`] ? 'is-invalid' : ''}`}
                                                value={experiencia.nivelExperiencia}
                                                onChange={(e) => handleExperienciaChange(index, 'nivelExperiencia', e.target.value)}
                                            >
                                                <option value="">Seleccionar</option>
                                                <option value="Senior">Senior</option>
                                                <option value="Semisenior">Semisenior</option>
                                                <option value="Junior">Junior</option>
                                                <option value="Pasante">Pasante</option>
                                            </select>
                                            {errors[`experiencia_${index}_nivelExperiencia`] && <div className="invalid-feedback">{errors[`experiencia_${index}_nivelExperiencia`]}</div>}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">País Empresa <RequiredAsterisk /></label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors[`experiencia_${index}_paisEmpresa`] ? 'is-invalid' : ''}`}
                                                value={experiencia.paisEmpresa}
                                                onChange={(e) => handleExperienciaChange(index, 'paisEmpresa', e.target.value)}
                                            />
                                            {errors[`experiencia_${index}_paisEmpresa`] && <div className="invalid-feedback">{errors[`experiencia_${index}_paisEmpresa`]}</div>}
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Personas a Cargo <RequiredAsterisk /></label>
                                            <input
                                                type="number"
                                                className={`form-control ${errors[`experiencia_${index}_personasCargo`] ? 'is-invalid' : ''}`}
                                                value={experiencia.personasCargo || ''}
                                                onChange={(e) => {
                                                    const value = Math.floor(Number(e.target.value));
                                                    if (value >= 0) {
                                                        handleExperienciaChange(index, 'personasCargo', value || 0);
                                                    }
                                                }}
                                                min="0"
                                                step="1"
                                                onKeyDown={(e) => {
                                                    if (e.key === "." || e.key === "e" || e.key === "-") {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            {errors[`experiencia_${index}_personasCargo`] && <div className="invalid-feedback">{errors[`experiencia_${index}_personasCargo`]}</div>}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Fecha inicio <RequiredAsterisk /></label>
                                            <div className="row">
                                                <div className="col-6">
                                                    <select
                                                        className={`form-select ${errors[`experiencia_${index}_fechaInicioMes`] ? 'is-invalid' : ''}`}
                                                        value={experiencia.fechaInicioExperiencia.mes}
                                                        onChange={(e) => handleExperienciaFechaChange(index, 'inicio', 'mes', e.target.value)}
                                                    >
                                                        <option value="">Mes</option>
                                                        {MESES.map(mes => (
                                                            <option key={mes.value} value={mes.value}>
                                                                {mes.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors[`experiencia_${index}_fechaInicioMes`] && (
                                                        <div className="invalid-feedback d-block">{errors[`experiencia_${index}_fechaInicioMes`]}</div>
                                                    )}
                                                </div>
                                                <div className="col-6">
                                                    <select
                                                        className={`form-select ${errors[`experiencia_${index}_fechaInicioAnio`] ? 'is-invalid' : ''}`}
                                                        value={experiencia.fechaInicioExperiencia.año}
                                                        onChange={(e) => handleExperienciaFechaChange(index, 'inicio', 'año', e.target.value)}
                                                    >
                                                        <option value="">Año</option>
                                                        {generarAnios().map(anio => (
                                                            <option key={anio} value={anio}>
                                                                {anio}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors[`experiencia_${index}_fechaInicioAnio`] && (
                                                        <div className="invalid-feedback d-block">{errors[`experiencia_${index}_fechaInicioAnio`]}</div>
                                                    )}
                                                </div>
                                            </div>
                                            {errors[`experiencia_${index}_fechaInicio`] && (
                                                <div className="text-danger small mt-1">{errors[`experiencia_${index}_fechaInicio`]}</div>
                                            )}
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Fecha finalización <RequiredAsterisk /></label>
                                            <div className="row">
                                                <div className="col-6">
                                                    <select
                                                        className={`form-select ${errors[`experiencia_${index}_fechaFinMes`] ? 'is-invalid' : ''}`}
                                                        value={experiencia.fechaFinalizacionExperiencia.mes}
                                                        onChange={(e) => handleExperienciaFechaChange(index, 'fin', 'mes', e.target.value)}
                                                    >
                                                        <option value="">Mes</option>
                                                        {MESES.map(mes => (
                                                            <option key={mes.value} value={mes.value}>
                                                                {mes.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors[`experiencia_${index}_fechaFinMes`] && (
                                                        <div className="invalid-feedback d-block">{errors[`experiencia_${index}_fechaFinMes`]}</div>
                                                    )}
                                                </div>
                                                <div className="col-6">
                                                    <select
                                                        className={`form-select ${errors[`experiencia_${index}_fechaFinAnio`] ? 'is-invalid' : ''}`}
                                                        value={experiencia.fechaFinalizacionExperiencia.año}
                                                        onChange={(e) => handleExperienciaFechaChange(index, 'fin', 'año', e.target.value)}
                                                    >
                                                        <option value="">Año</option>
                                                        {generarAnios().map(anio => (
                                                            <option key={anio} value={anio}>
                                                                {anio}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors[`experiencia_${index}_fechaFinAnio`] && (
                                                        <div className="invalid-feedback d-block">{errors[`experiencia_${index}_fechaFinAnio`]}</div>
                                                    )}
                                                </div>
                                            </div>
                                            {errors[`experiencia_${index}_fechaFinalizacion`] && (
                                                <div className="text-danger small mt-1">{errors[`experiencia_${index}_fechaFinalizacion`]}</div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Descripción de responsabilidad <RequiredAsterisk /></label>
                                        <textarea
                                            className={`form-control ${errors[`experiencia_${index}_descripcionResponsabilidad`] ? 'is-invalid' : ''}`}
                                            value={experiencia.descripcionResponsabilidad}
                                            onChange={(e) => handleExperienciaChange(index, 'descripcionResponsabilidad', e.target.value)}
                                            rows="3"
                                        />
                                        {errors[`experiencia_${index}_descripcionResponsabilidad`] && <div className="invalid-feedback">{errors[`experiencia_${index}_descripcionResponsabilidad`]}</div>}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="mb-4 formacion-item-content border p-3 mb-3 rounded">
                            <h4 className="border-bottom pb-2">SUBIR CV <RequiredAsterisk /></h4>
                            <div className="mb-3">
                                <label className="form-label">Subir Archivo CV (PDF, Word) <RequiredAsterisk /></label>
                                <input
                                    type="file"
                                    className={`form-control ${errors.cv ? 'is-invalid' : ''}`}
                                    name="cv"
                                    onChange={handleInputChange}
                                    accept=".pdf,.doc,.docx"
                                />
                                {errors.cv && <div className="invalid-feedback">{errors.cv}</div>}
                                <small className="form-text text-muted">
                                    Formatos aceptados: PDF, DOC, DOCX. Tamaño máximo: 5MB
                                </small>
                            </div>
                        </div>

                        <div className="mb-4">
                            <div className="box mt-2 p-2 text-content" style={{ backgroundColor: "#f8f9fa", border: "1px solid #ced4da", borderRadius: "5px" }}>
                                La información transmitida, incluidos los archivos adjuntos, está destinada únicamente a la(s) persona(s) o entidad a la que se dirige y puede contener material confidencial y/o privilegiado. Queda prohibida cualquier revisión, retransmisión, difusión u otro uso, o cualquier acción basada en esta información por parte de personas o entidades que no sean el destinatario previsto. Para acceder a nuestra Política de Tratamiento de Datos Personales <a href="https://www.conduto.com/images/dp/POLITICA-DE-TRATAMIENTO-DE-DATOS-PERSONALES.pdf" target="_blank" rel="noopener noreferrer">aquí</a>, y si desea comunicarse con nosotros tenga a su disposición el correo: <a href="mailto:datospersonales@conduto.com">datospersonales@conduto.com</a>
                            </div>
                            <br />
                            <div className="form-check">
                                <input
                                    style={{
                                        width: "18px",
                                        height: "18px",
                                        border: "2px solid #014993",
                                        backgroundColor: acceptedTerms ? "#014993" : "#eee",
                                        appearance: "none",
                                        cursor: "pointer"
                                    }}
                                    className={`form-check-input ${errors.terms ? 'is-invalid' : ''}`}
                                    type="checkbox"
                                    id="termsCheck"
                                    checked={acceptedTerms}
                                    onChange={(e) => {
                                        setAcceptedTerms(e.target.checked);
                                        if (errors.terms) {
                                            setErrors(prev => ({ ...prev, terms: '' }));
                                        }
                                    }}
                                />
                                <label className="form-check-label" htmlFor="termsCheck">
                                    Autorizo el tratamiento de mis datos personales a Conduto Ecuador S.A. conforme lo establecido en su política de privacidad <RequiredAsterisk />
                                </label>
                                {errors.terms && <div className="invalid-feedback d-block">{errors.terms}</div>}
                            </div>
                        </div>

                        <div className="d-grid gap-2">
                            {showSuccess && (
                                <SuccessMessage
                                    message="Hoja de vida guardada correctamente"
                                    onClose={() => setShowSuccess(false)}
                                />
                            )}

                            {errors.submit && <ErrorMessage message={errors.submit} />}
                            <button
                                type="submit"
                                className="btn btn-primary btn-lg"
                                disabled={isSubmitting || !acceptedTerms}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Guardando...
                                    </>
                                ) : (
                                    'Guardar Hoja de Vida'
                                )}
                            </button>
                        </div>
                        <br />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Formulario;